<template>
  <r-panel :disabled="disabled" :title="title" :empty="items.length === 0" :button_add="true" @click_add="click_add">
    <r-card-table ref="table" :items.sync="values" :toolbar="false" :duplicate="true"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCardTable from "@/modules/redactor/views/card/r-card-table.vue";

export default {
  name: "r-card-panel",
  components: {RCardTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Card"),
    items: VueTypes.arrayOf(VueTypes.string) //CardModel_UID
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>
